	export enum PatientPreferredContactEnum {
		Mail = 1,
		Email = 2,
		PhoneCall = 3,
		TextMessage = 4
	}
